module.exports = __webpack_public_path__ + "static/email-marketing-automation-sprinkles-6ec4ae38e9bf0d8467a939a2d56bc8a3.svg";